import React from 'react'

const Diff = ({ data }) => {

    let _data = {}

    try {
        _data = JSON.parse(data.replaceAll('\'', '"'))
    } catch (e) {
        return null
    }

    const changed_fields = _data.changed_fields
    const update_values = _data.update_values

    return (
        <> {changed_fields && update_values &&
            <dl>{changed_fields.map((field, index) => <>
                <dt>{gettext(field)}</dt>
                <dd><span className="diff-old">{update_values[field].old}</span> &rarr; <span className="diff-new">{update_values[field].new}</span></dd>
            </>
            )}
            </dl>
        }</>
    )

}

export default Diff